import { useQuery } from "@tanstack/react-query"
import { ProfileForm } from "@/components/profile/ProfileForm"
import { supabase } from "@/integrations/supabase/client"

export default function Profile() {
  const { data: profile, refetch } = useQuery({
    queryKey: ["profile"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) throw new Error("User not found")

      const { data, error } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", user.id)
        .single()

      if (error) throw error
      return data
    },
  })

  return (
    <div className="container max-w-2xl mx-auto py-10">
      <div className="space-y-8">
        {profile && (
          <ProfileForm 
            initialData={{
              first_name: profile.first_name || "",
              last_name: profile.last_name || "",
              state: profile.state || "",
              city: profile.city || "",
              avatar_url: profile.avatar_url || "",
            }}
            onProfileUpdate={refetch}
          />
        )}
      </div>
    </div>
  )
}